// import AjaxSearch from './ajax-search';

const SearchTrigger = {

  /**
   * Triggers
   * @type {Node}
  */
  elements: document.querySelectorAll('.ce_rsce_search_trigger'),

  /**
   * Search mod
   * @type {Node}
  */
  searchMod: document.querySelector('header .mod_search'),

  /**
   * Overlay
   * @type {Node}
  */
  overlay: document.querySelector('#overlay'),

  /**
   * classes
   * @type {Object}
  */
  class: {
    open: 'open'
  },

  /**
   * Methods
   * @type {Function}
  */
  close() {
    this.searchMod.classList.remove(this.class.open);
    this.overlay.classList.remove(this.class.open);
  },

  open() {
    this.searchMod.classList.add(this.class.open);
    this.overlay.classList.add(this.class.open);
    this.searchMod.querySelector('input[type="search"]').focus();
  },


  init() {
    /**
     * case check
    */
    if(this.elements.length <= 0 || !this.searchMod || !this.overlay) {
      return;
    }

    /**
     * open
    */
    this.elements.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        this.open();
      });
    });

    /**
     * close
    */
    this.overlay.addEventListener('click', () => {
      this.close();
    });

    document.addEventListener('keydown', (e) => {
      if(e.key === "Escape") {
        this.close();
      }
    });

    /**
     * ajax results
    */
    // this.searchMod.querySelector('input[type="search"]').addEventListener('keyup', function() {
    //   const search = document.querySelector('header .mod_search');
    //   new AjaxSearch(search, search.querySelector('.test'));
    // });

  }
}

export default SearchTrigger.init();
